module.exports = __webpack_public_path__ + "media/images/guides/random-02-325adf2f5d6b5b9ffc32a186dcaab836.svg";